<template>
    <div>
        <div class="list" v-for="item in listData.item" :key="item.id">
          <div v-if="item.id == 5 || item.id == 8 || item.id == 7 || item.id == 4 || item.id == 11 || item.id == 6 || item.id == 13 || item.id == 12 || item.id == 15 || item.id == 16  || item.id == 17">
            <div class="list-txt">{{ item.name }}</div>
            <p class="tips" v-if="item.id == 17">{{ $t('guild_page_fee') }}</p>
            <div style="display:flex;flex-wrap: wrap;">
              <div
                class="list-box"
                v-for="Aitem in item.list"
                :key="Aitem.id"
                @click="channelBtn(item, Aitem)"
              >
                <div class="money">{{ Aitem.cc }} {{ Aitem.num }}</div>
                <div class="money-box">
                  <img
                    class="money-img"
                    src="../../assets/withdrawal/coin.png"
                    alt=""
                  />
                  <div class="money-num">{{ Aitem.usd }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="item.id == 10 || item.id == 9">
            <div class="list-txt">{{ item.name }}</div>
            <div style="display:flex;flex-wrap: wrap;">
              <div
                  class="list-box"
                  v-for="Aitem in item.list"
                  :key="Aitem.id"
                  @click="channelPixBtn(item, Aitem)"
              >
                <div class="money">{{ Aitem.cc }} {{ Aitem.num }}</div>
                <div class="money-box">
                  <img
                      class="money-img"
                      src="../../assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png"
                      alt=""
                  />
                  <div class="money-num">{{ Aitem.usd }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="meta-box" v-if="loading">
            <van-loading
                type="spinner"
                color="#cccccc"
                size="20px"
            />
        </div>
    <van-popup
      v-model:show="show"
      closeable
      round
      position="bottom"
      :style="{ height: '20%' }"
      class="popup"
      >{{ $t("withdrawalLogin.Pocket") }}</van-popup
    >
    </div>
</template>
<script>
import axios from "axios";
import { Toast,Popup,Loading } from "vant";
    export default {
        name: "withdrawal-list",
        components: {
            VanPopup: Popup,
            [Loading.name]: Loading 
        },
        data() {
            return {
                client: 'PC',
                listData: {},
                token: "",
                uid: "",
                lang: "",
                show: false,
                deviceId: '',
                loading:false
            }
        },
        created(){
            var ids = navigator.userAgent.match(
            /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
            );
            if (ids) {
            ids = ids[0];
            } else {
            ids = "Unknown Device";
            }
            let data = JSON.parse(localStorage.getItem("data"));
            this.token = data.token;
            this.uid = data.uid || data.userId;
            this.lang = data.lang || navigator.language;
            this.deviceId = data.deviceId || ids
            this.contact();
            if(data.uid){
                this.changeTime()
            }
            this.judgeClient();
        },
        methods: {

    // 判断平台
    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        this.client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
        this.client = 'Android';
      } else {
        this.client = 'PC';
      }
      return this.client;
    },
            contact() {
                axios
                    .get(this.$serviceIp +`/api/trade/card/tx/getInfoForWeb?token=${this.token}&uid=${this.uid}`,{
                        headers: {
                            'deviceId': this.deviceId
                        }
                    })
                    .then((response) => {
                    if (response.data.code == 200) {
                        this.listData = response.data.data;
                        this.sortList(this.listData.item);
                    } else {
                        Toast(response.data.message || this.$t("transfer.error"));
                    }
                    }).catch(()=>{

                    }).finally(()=>{
                        this.loading = false
                    });
            },
    // 排序
    sortList(item){
      item.forEach(element => {
        element.list.sort((a, b) => {
          return a.sort - b.sort;
        });
      });
    },
            changeTime() {
                let item = JSON.parse(localStorage.getItem("time"));
                if (item < Date.now()) {
                    localStorage.removeItem("data");
                    localStorage.removeItem("time");
                    this.$router.push("/withdrawalLogin");
                }
            },
            
    channelBtn(item, Aitem) {
        console.log(this.listData.cin, Aitem.usd)
      if (this.listData.cin < Aitem.usd) {
        this.show = true;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${item.id}`,{
              headers: {
                'deviceId': this.deviceId
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              path: "/withdrawalDetails",
              query: {
                obj: JSON.stringify(response.data.data.infos),
                newobj: JSON.stringify(Aitem),
                id:item.id,
                sabankList: JSON.stringify(response.data.data.sabankList) || ''
              },
            });
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },
            
    channelPixBtn(item, Aitem) {
      if (this.listData.cin < Aitem.usd) {
        this.show = true;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `/api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${item.id}`,{
              headers: {
                'deviceId': this.deviceId
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              path: "/pixDetails",
              query: {
                obj: JSON.stringify(response.data.data.infos),
                newobj: JSON.stringify(Aitem),
              },
            });
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },
        }
    }
</script>
<style scoped>

.popup {
  font-size: 0.24rem;
  color: #000000;
  font-weight: 500;
  font-family: Rubik;
  display: flex;
  justify-content: center;
  align-items: center;
}
html[lang="ar"] .list {
  direction: rtl;
}
.meta-box{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
}
.list {
  width: 100%;
  /* height: 1.9rem; */
  margin-bottom: 0.4rem;
}
.list .list-box:nth-of-type(3n+1) {
  margin-left: 0;
}
.list-box {
  width: 166px;
  min-height: 128px;
  margin-top: 0.3rem;
  margin-left: 22px;
  border-radius: 24px;
  /* border: 1px solid rgba(0, 210, 147, 1); */
  background: #E8ECF0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.list-txt {
  height: 0.32rem;
  font-size: 0.27rem;
  font-family: Rubik;
  color: rgba(0, 0, 0, 1);
}
.tips{
  height: 0.32rem;
  font-size: 0.20rem;
  font-family: Rubik;
  color: rgba(0, 0, 0, 0.7);

}
.money {
  width: 80%;
  min-height: 0.43rem;
  font-size: 0.37rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
}

.money-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.money-img {
  width: 0.27rem;
  height: 0.27rem;
}

.money-num {
  /* width: 0.6rem; */
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.24rem;
  color: #89848D;
  font-weight: 500;
  font-family: Rubik;
}
</style>